function DriverAdditionalFields() {
    const fields = {
      course_1_completion_date:'course_1_completion_date',
      course_2_completion_date:'course_2_completion_date',
      course_3_completion_date:'course_3_completion_date',
      course_4_completion_date:'course_4_completion_date',
      course_5_completion_date:'course_5_completion_date'
    };
    return fields;
  }
  export default DriverAdditionalFields;
